import { useEffect, useRef, useState } from "react";
import { useTheme } from "../context/ThemeContext";
import style from "./NavigationBar/NavStyle.module.css";

// Small inline icons per theme
const icons = {
  "mui-light": (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  ),
  dark: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  ),
};

export default function ThemeToggle({ className = "" }) {
  const { theme, themes, setTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close on outside click / Escape
  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const current = themes.find((t) => t.id === theme) || themes[0];

  return (
    <div className={`${style.themeMenuWrap} ${className}`.trim()} ref={ref}>
      <button
        type="button"
        className={style.themeToggle}
        onClick={() => setOpen((o) => !o)}
        aria-label="Choose theme"
        aria-haspopup="true"
        aria-expanded={open}
        title={`Theme: ${current.label}`}
      >
        {icons[current.id]}
      </button>

      {open && (
        <ul className={style.themeMenu} role="menu">
          {themes.map((t) => (
            <li key={t.id} role="none">
              <button
                type="button"
                role="menuitemradio"
                aria-checked={t.id === theme}
                className={`${style.themeMenuItem} ${t.id === theme ? style.themeMenuItemActive : ""}`}
                onClick={() => {
                  setTheme(t.id);
                  setOpen(false);
                }}
              >
                <span className={style.themeMenuIcon}>{icons[t.id]}</span>
                {t.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
